import { render, staticRenderFns } from "./OrganizationModalAddMember.vue?vue&type=template&id=2c6f9f2e&scoped=true"
import script from "./OrganizationModalAddMember.vue?vue&type=script&lang=js"
export * from "./OrganizationModalAddMember.vue?vue&type=script&lang=js"
import style0 from "./OrganizationModalAddMember.vue?vue&type=style&index=0&id=2c6f9f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6f9f2e",
  null
  
)

export default component.exports